import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private auth: AuthService,
        private router: Router) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (this.auth.isLoggedIn()) {
            return true;
        }
        else {

            return new Promise((resolve, reject) => {
                setTimeout(() => {

                    if (this.auth.isLoggedIn()) {
                        resolve(true);
                    }
                    else {
                        this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
                        resolve(false);
                    }

                }, 100);
            });
        }

    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/_services/auth.guard.ts